export const trainingTestWarningTreshold = 0.9
